import { render, staticRenderFns } from "./TargetGroups.vue?vue&type=template&id=4bc71096&scoped=true&"
import script from "./TargetGroups.vue?vue&type=script&lang=js&"
export * from "./TargetGroups.vue?vue&type=script&lang=js&"
import style0 from "./TargetGroups.vue?vue&type=style&index=0&id=4bc71096&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc71096",
  null
  
)

export default component.exports